import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { defineComponent, computed, toRefs, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import { capitalize } from "lodash";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import { RISK_LEVEL } from "@Shared/js/enum";
export default defineComponent({
  name: "SelectRiskLevel",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedRiskLevels: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    levelsToExclude: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      selectedRiskLevels,
      multiple,
      levelsToExclude,
      action
    } = toRefs(props);
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const select = ref();
    const actionRef = ref(action);
    const riskLevelOptions = computed(() => {
      var _context, _context2;
      return [{
        id: "all",
        text: capitalize(tc("global.words.all", 1))
      }, ..._mapInstanceProperty(_context = _filterInstanceProperty(_context2 = _Object$entries(RISK_LEVEL)).call(_context2, ([, value]) => {
        var _context3;
        return !_includesInstanceProperty(_context3 = levelsToExclude.value).call(_context3, value);
      })).call(_context, ([key, value]) => ({
        id: value,
        text: capitalize(t(`application.riskLevel.${key}`).toString())
      }))];
    });
    const localSelectedRiskLevels = computed({
      get() {
        var _selectedRiskLevels$v;
        return (_selectedRiskLevels$v = selectedRiskLevels.value) != null ? _selectedRiskLevels$v : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedRiskLevels", newValue);
      }
    });
    const handleChange = (selectedValue, type) => {
      var _select$value;
      if (selectedValue.id === "all" && type === "select") (_select$value = select.value) == null ? void 0 : _select$value.close();
      localSelectedRiskLevels.value = handleSelectMultipleChange(selectedValue, type, localSelectedRiskLevels.value, multiple.value);
    };
    return {
      select,
      riskLevelOptions,
      localSelectedRiskLevels,
      actionRef,
      handleChange
    };
  }
});